import { get } from 'lodash'

import { Colors, Services, regExp } from '@sigma-frontend-libs/commons'

import { components, sizes } from '@/utils'

import PasswordField from '@/components/services/users/form/basic/password'
import phone from '@/components/services/users/form/basic/phone'
import tag from '@/components/tag'

function renderIsActiveField(h) {
  if (this.canUpdateUsers) {
    const value = this.proxy.isActive

    return h(
      components.switch,
      {
        props: {
          value,
          label: this.getTranslate(`${Services.users}.labels.isActive.${value}`),
          tooltip: this.getTranslate(`${Services.users}.tooltips.isActive`),
          outline: true
        },
        on: {
          input: event => {
            this.proxy.isActive = event
          }
        }
      }
    )
  }
}
function renderHasContractField(h) {
  if (this.proxy.data?.partnership) {
    if (this.canUpdateUsers) {
      const value = this.proxy.data?.partnership?.hasContract
      if (this.canSetHasContract) {
        return h(
          components.switch,
          {
            props: {
              value,
              label: this.getTranslate(`${Services.users}.labels.data.partnership.hasContract.${value}`),
              outline: true
            },
            on: {
              input: event => {
                this.proxy.data.partnership.hasContract = event
              }
            }
          }
        )
      } else {
        let contractColor
        if (value) {
          contractColor = Colors.success
        } else {
          contractColor = Colors.error
        }

        return h(
          tag,
          {
            props: {
              label: this.getTranslate(`${Services.users}.labels.data.partnership.hasContract.${value}`),
              color: contractColor,
              size: sizes.huge
            }
          }
        )
      }
    }
  }
}

function renderUsernameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.username,
        label: this.getTranslate(`${Services.users}.labels.username`),
        error: this.errors.username,
        mask: this.usernameMask,
        disabled: !this.canUpdateUsers,
        trim: true,
        dense: true,
        required: true,
        clearable: true,
        details: false,
        tabindex: 1
      },
      on: {
        input: event => {
          this.proxy.username = event
        }
      }
    }
  )
}
function renderPasswordField(h) {
  return h(
    PasswordField,
    {
      props: {
        value: this.proxy.password,
        isNew: this.isNew,
        saveSuccessKey: this.saveSuccessKey
      },
      on: {
        input: event => {
          this.$set(this.proxy, 'password', event)
        }
      }
    }
  )
}
function renderEmailField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.email,
        label: this.getTranslate(`${Services.users}.labels.data.email`),
        error: get(this.errors, 'data.email'),
        trim: true,
        dense: true,
        clearable: true,
        required: true,
        details: false,
        tabindex: 3
      },
      on: {
        input: event => {
          this.proxy.data.email = event
        }
      }
    }
  )
}
function renderPhoneField(h) {
  return h(
    phone,
    {
      props: {
        value: this.proxy,
        errors: this.errors
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
function renderFirstNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.firstName,
        label: this.getTranslate(`${Services.users}.labels.data.firstName`),
        error: get(this.errors, 'data.firstName'),
        mask: regExp.safeName,
        trim: true,
        dense: true,
        clearable: true,
        details: false,
        tabindex: 5
      },
      on: {
        input: event => {
          this.proxy.data.firstName = event
        }
      }
    }
  )
}
function renderLastNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.lastName,
        label: this.getTranslate(`${Services.users}.labels.data.lastName`),
        error: get(this.errors, 'data.lastName'),
        mask: regExp.safeName,
        trim: true,
        dense: true,
        clearable: true,
        details: false,
        tabindex: 6
      },
      on: {
        input: event => {
          this.proxy.data.lastName = event
        }
      }
    }
  )
}
function renderReferralCodeField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.referralCode,
        label: this.getTranslate(`${Services.users}.labels.referralCode`),
        error: this.errors.referralCode,
        defaultValue: '',
        details: false,
        trim: true,
        dense: true,
        clearable: true,
        tabindex: 7
      },
      on: {
        input: event => {
          this.proxy.referralCode = event
        }
      }
    }
  )
}
function renderUsedReferralCodeField(h) {
  if (this.canGetAndUpdateUsedReferralCode) {
    if (this.proxy.data && this.proxy.data.meta) {
      return h(
        components['text-field'],
        {
          props: {
            value: this.proxy.data.meta.usedReferralCode,
            label: this.getTranslate(`${Services.users}.labels.data.meta.usedReferralCode`),
            error: get(this.errors, 'data.meta.usedReferralCode'),

            trim: true,
            dense: true,
            clearable: true,
            details: false,
            tabindex: 8
          },
          on: {
            input: event => {
              this.$set(this.proxy.data.meta, 'usedReferralCode', event)
            }
          }
        }
      )
    }
  }
}
function renderContent(h) {
  return h(
    'div',
    {
      class: `${Services.users}-form__content`
    },
    [
      renderIsActiveField.call(this, h),
      renderHasContractField.call(this, h),
      renderUsernameField.call(this, h),
      renderPasswordField.call(this, h),
      renderEmailField.call(this, h),
      renderPhoneField.call(this, h),
      renderFirstNameField.call(this, h),
      renderLastNameField.call(this, h),
      renderReferralCodeField.call(this, h),
      renderUsedReferralCodeField.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.users}-form ${Services.users}-form--${this.classModifier}`
    },
    [
      renderContent.call(this, h),

      this.$slots.default
    ]
  )
}
